import { useEffect, useState } from 'react'
import { universeContract } from '../utils/contracts';
import { useWeb3Context } from './useWeb3Context';

function useIsPaused() {
  const [isPaused, setIsPaused] = useState(false);
  const [isPausedLoading, setIsPausedLoading] = useState(true);
  const { provider } = useWeb3Context();

  useEffect(() => {
    const getPaused = async () => {
      const paused = await universeContract(provider).paused();
      if(paused || !paused) {
        setIsPaused(paused);
        setIsPausedLoading(false);
      }
    }

    getPaused()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    return () => {
      setIsPaused(false);
    };
  }, []);

  return {
    isPaused,
    isPausedLoading
  };
}

export default useIsPaused;